import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { LoginResponse } from '../../types/auth/login-data.type';

const endpoints = {
  rbaLogin: (tenantName: string) => `${environment.baseApiRoute}/auth/rba-idp-login/${tenantName}`,
  microsoft365Login: (tenantName: string) => `${environment.baseApiRoute}/auth/o365-login/${tenantName}`,
};

const CODE_VERIFIER = 'OToOq8XykDr1-zpZucPUC--DH0lkk6bYbrg6wFIX4ZLACHob56S10MkUWwexDMuOAiV-cUn5eN1sOE2m0etWLtWOmG-Qqez1kpk2Vd2TKBV_0NbCwbzIK0LBGPt1a52u';

@Injectable({ providedIn: 'root' })
export class ThirdPartyLoginService {
  private readonly http = inject(HttpClient);

  getRbaAlbaniaToken(tenantName: string, code: string) {
    return this.http.post<LoginResponse>(endpoints.rbaLogin(tenantName), {
      code,
      redirect_uri: 'https://web.jenz.app/oauth-callback',
      code_verifier: CODE_VERIFIER,
    });
  }

  microsoft365Login(tenantName: string, code: string, redirectUri: string) {
    return this.http.post<LoginResponse>(endpoints.microsoft365Login(tenantName), {
      code,
      redirect_uri: redirectUri,
      code_verifier: CODE_VERIFIER,
    });
  }
}
